import {dataHooks} from '@wix/data-hooks'

export const tagsListDataHooks = dataHooks<{
  timeSlot: {index: number; available: boolean}
}>('tags-list')
